import React from "react";
import { AuthProvider as OidcAuthProvider } from "react-oidc-context";
import cognitoAuthConfig from "../config/authConfig";
import { AuthProviderProps } from "../types/auth.types";

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    return (
        <OidcAuthProvider {...cognitoAuthConfig}>
            {children}
        </OidcAuthProvider>
    );
};
